import React from 'react';

const TONE = {
  success: 'badge-tone-success',
  warning: 'badge-tone-warning',
  danger: 'badge-tone-danger',
  info: 'badge-tone-info',
  muted: 'badge-tone-muted',
  primary: 'badge-tone-primary',
};

export default function StatusBadge({ children, tone = 'muted' }) {
  return <span className={`status-badge ${TONE[tone] || TONE.muted}`}>{children}</span>;
}

export function accountTone(accountType) {
  const t = String(accountType || '').toLowerCase();
  if (t === 'trial') return 'warning';
  if (t === 'frozen' || t === 'cancelled') return 'danger';
  if (t.includes('pro') || t === 'paid') return 'success';
  return 'muted';
}

export function actionTone(action) {
  const a = String(action || '').toLowerCase();
  if (a === 'deleted') return 'danger';
  if (a === 'added') return 'success';
  if (a === 'updated') return 'info';
  return 'muted';
}
